<template lang="pug">
UiPage(:title="$t('admin_users.title')")
  .container
    UiCard
      UiCardSection(v-if="error !== null")
        UiAlert(
          variant="error"
          :title="error"
        ) 
      UiCardSection
        RestTable(
          namespace="company_users"
          :headers="headers"
          ref="adminUsersTable"
          :fetch-handler="getData"
          :initial-filters="initialFilters"
          embed
        )
          template(#filters="{ filters, updateFilters }")
            UiStack
              UiStackItem
                UiFormGroup(:label="$t('admin_users.user_name')") 
                  UiInput(
                    :modelValue="filters.search"
                    type="search"
                    inputSize="40"
                    @update:modelValue="updateFilters({ search: $event })"
                  )
              UiStackItem
                UiFormGroup(:label="$t('admin_users.company')") 
                  UiInput(
                    :modelValue="filters.company"
                    type="search"
                    inputSize="40"
                    @update:modelValue="updateFilters({ company: $event })"
                  )
          template(#cell:role="{ item }")
            | {{ item.role && $t(`roles.${item.role}`) }}
          template(#cell:actions="{ item }")
            UiStack(spacing="xs")
              UiStackItem
                UiButton(
                  size="sm"
                  variant="smooth-primary"
                  @click="editUser(item)"
                  icon="PencilCreate"
                ) {{ $t("actions.edit") }}
              UiStackItem
                UiButton(
                  size="sm"
                  variant="smooth-danger"
                  @click="deleteUser(item)"
                  icon="Trash"
                ) {{ $t("actions.delete") }}
  EditUserModal(
    ref="EditUserModal"
    @done="reloadList"
  )
</template>
<script>
import ApiAdminUsers from "@/api/admin_user.js";
import EditUserModal from "@/modals/AdminUsers/editUser.vue";

export default {
  components: {
    EditUserModal,
  },

  data() {
    return {
      error: null,
      initialFilters: {
        company: "",
      },
      headers: [
        {
          key: "id",
          label: "#",
          sortable: true,
          squeeze: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
          width: "25%",
        },
        {
          key: "email",
          label: "email",
          sortable: true,
          width: "25%",
        },
        {
          key: "role",
          label: "role",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },

  methods: {
    reloadList() {
      this.$refs.adminUsersTable.fetchData();
    },

    getData(params, config) {
      return ApiAdminUsers.fetchUsers(params, config).then((resp) => {
        this.error = null;
        return {
          items: resp.data.users,
          meta: resp.data.meta,
        };
      });
    },

    deleteUser(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "account-minus",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiAdminUsers.deleteUser(item.id).then((resp) => {
          this.reloadList();
          this.error = resp.data.error || null;
        });
      });
    },

    editUser(item) {
      this.$refs.EditUserModal.open(item);
    },
  },
};
</script>
